var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.7335 0 0 6.7335 0 15C0 23.2665 6.7335 30 15 30C23.2665 30 30 23.2665 30 15C30 6.7335 23.2665 0 15 0ZM15 3C21.6452 3 27 8.35482 27 15C27 21.6452 21.6452 27 15 27C8.35482 27 3 21.6452 3 15C3 8.35482 8.35482 3 15 3ZM10.0605 7.93945L7.93945 10.0605L12.8789 15L7.93945 19.9395L10.0605 22.0605L15 17.1211L19.9395 22.0605L22.0605 19.9395L17.1211 15L22.0605 10.0605L19.9395 7.93945L15 12.8789L10.0605 7.93945Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fa1dddde6ae9ac97d824d3ebae784f59.svg";
export { ForwardRef as ReactComponent };